export default __webpack_public_path__ + "styles/icons/2500mLBottle.svg";